var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineDarkGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "139px",
    height: "105px",
    viewBox: "0 0 139 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jziwa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38 67V38h63v29zm2.5-14.5c0 6.627 5.373 12 12 12 5.946 0 10.881-4.324 11.834-10H98.5v-4H64.334c-.952-5.675-5.888-10-11.834-10-6.627 0-12 5.373-12 12z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00604b",
    d: "M52.5 40.5c5.946 0 10.882 4.325 11.834 10H98.5v4H64.334c-.953 5.676-5.888 10-11.834 10-6.627 0-12-5.373-12-12s5.373-12 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M52.5 40.5c5.946 0 10.882 4.325 11.834 10H98.5v4H64.334c-.953 5.676-5.888 10-11.834 10-6.627 0-12-5.373-12-12s5.373-12 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 20,
    strokeWidth: 4,
    d: "M52.5 40.5c5.946 0 10.882 4.325 11.834 10H98.5v4H64.334c-.953 5.676-5.888 10-11.834 10-6.627 0-12-5.373-12-12s5.373-12 12-12z",
    clipPath: "url(\"#jziwa\")"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDarkGreen);
export default __webpack_public_path__ + "static/media/lineDarkGreen.04ce6b9992abe2b73d8ebafd4cfcbcff.svg";
export { ForwardRef as ReactComponent };